class FirebaseService {
    logEvent(event_name, item) {
        try {
            // Dynamically import to avoid errors when Firebase isn't configured
            const { getApps } = require("firebase/app");
            if (getApps().length === 0) return;

            const { getAnalytics, logEvent } = require("firebase/analytics");
            const analytics = getAnalytics();
            logEvent(analytics, event_name, item);
        } catch (error) {
            // Silently ignore Firebase errors
        }
    }
}

export default new FirebaseService();